<template>
  <div>
    <hr />
    <div
        style="margin-bottom: 10px"
        v-for="(aScripture, i) in scriptures"
        :key="`script-${i}`">
      "{{aScripture.text}}" <strong>- {{ bookChapterVerseFix(aScripture) }} </strong>
    </div>
  </div>
</template>

<script>
export default {
  name: "Display_PaneResponse_Scriptures",
  components: {},
  created(){},
  mounted() {},
  props: {
    scriptures: {
      type: Array,
      required: false,
      default:()=>{[]}
    }
  },
  computed: {},
  methods: {
    bookChapterVerseFix(aScripture){
      if(aScripture.book_chapter_vers) return aScripture.book_chapter_vers;
      if(aScripture.book_chapter_verse) return aScripture.book_chapter_verse;
      return "The Bible";
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
